import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { register } from '../api/auth'

export default function Signup() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [showPassword, setShowPassword] = useState(false)
  const [error, setError] = useState(null)
  const [f, setF] = useState({
    username: '',
    email: '',
    firstName: '',
    lastName: '',
    phone: '',
    password: ''
  })
  const up = (k, v) => setF(prev => ({ ...prev, [k]: v }))

  async function handleSubmit(e){
    e.preventDefault()
    setError(null)
    try {
      await register(f)
      navigate('/login')
    } catch (err) {
      console.error(err)
      setError(t('auth.signup_failed', 'Inscription impossible'))
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white shadow-md rounded-2xl w-full max-w-md p-8">
        <h1 className="text-3xl font-extrabold text-blue-900 mb-2 text-center">
          {t('auth.signup', 'Inscription')}
        </h1>
        <p className="text-gray-600 text-center mb-8">
          {t('auth.createAccount', 'Créer le compte')}
        </p>

        {error && <div className="mb-4 text-red-700 bg-red-50 border border-red-200 rounded px-3 py-2">{error}</div>}

        <form onSubmit={handleSubmit} className="space-y-5">
          <Field label={t('auth.username','Nom d’utilisateur')} placeholder={t('auth.username','Nom d’utilisateur')} value={f.username} onChange={v=>up('username',v)} />
          <Field type="email" label={t('auth.email','E-mail')} placeholder="E-mail" value={f.email} onChange={v=>up('email',v)} />
          <Field label={t('auth.firstName','Prénom')} placeholder={t('auth.firstName','Prénom')} value={f.firstName} onChange={v=>up('firstName',v)} />
          <Field label={t('auth.lastName','Nom')} placeholder={t('auth.lastName','Nom')} value={f.lastName} onChange={v=>up('lastName',v)} />
          <Field label={t('auth.phone','Téléphone')} placeholder={t('auth.phone','Téléphone')} value={f.phone} onChange={v=>up('phone',v)} />

          <div className="relative">
            <label className="block font-semibold text-gray-700 mb-1">{t('auth.password','Mot de passe')}</label>
            <input
              type={showPassword ? 'text' : 'password'}
              required
              placeholder={t('auth.password','Mot de passe')}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={f.password}
              onChange={(e)=>up('password', e.target.value)}
            />
            <button type="button" className="absolute right-3 top-9 text-gray-500" onClick={()=>setShowPassword(s=>!s)} aria-label="Afficher/masquer le mot de passe">
              {showPassword ? '🙈' : '👁️'}
            </button>
          </div>

          <button type="submit" className="w-full py-3 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 transition">
            {t('auth.signup','Inscription')}
          </button>
        </form>

        <p className="text-center text-gray-700 mt-6">
          {t('authui.haveAccount','Vous avez déjà un compte ?')}{' '}
          <Link to="/login" className="text-blue-600 font-semibold hover:underline">
            {t('auth.login','Connexion')}
          </Link>
        </p>
      </div>
    </div>
  )
}

function Field({ label, placeholder, value, onChange, type='text' }) {
  return (
    <div>
      <label className="block font-semibold text-gray-700 mb-1">{label}</label>
      <input
        type={type}
        required
        placeholder={placeholder}
        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
        value={value}
        onChange={(e)=>onChange(e.target.value)}
      />
    </div>
  )
}
